import _ from 'lodash';

const isEmptyValue = value => {
  if (value === undefined || value === null) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};

export const createTabbedFormMethods = component => {
  const getSchemaFromPath = key => {
    const path = key.replace(/\./g, '.properties.').replace(/^\./, '');
    return _.get(component.state.schema, path);
  };

  const isLastTab = () => {
    const tabs = component.state.schema?.meta?.tabs || [];
    if (!Array.isArray(tabs) || !Number.isInteger(component.state.activeTabIndex)) return false;
    return component.state.activeTabIndex === tabs.length - 1;
  };

  const isFieldRequired = keyPath => {
    const segments = (keyPath || '').split('.');
    const fieldKey = segments.pop();
    const parentPath = segments.join('.');
    const parentSchema = parentPath ? getSchemaFromPath(parentPath) : component.state.schema;
    const requiredList = parentSchema?.required || [];
    return requiredList.includes(fieldKey);
  };

  const isCheckBoxWithDynamicInputField = keyPath => {
    const segments = (keyPath || '').split('.');
    const parentPath = segments.join('.');
    const { uiSchema } = component.state;
    return uiSchema?.[parentPath]?.['ui:field'] === 'checkbox_with_inputs';
  };

  const isCheckBoxWithDynamicInputFieldRequired = keyPath => {
    const segments = (keyPath || '').split('.');
    const parentPath = segments.join('.');
    return component.state.formData?.[parentPath]?.selected?.some(
      // eslint-disable-next-line no-unsafe-optional-chaining
      value => !(`${value}_input` in component.state.formData?.[parentPath])
    );
  };

  const tabHasMissingRequired = () => {
    const tabs = component.state.schema?.meta?.tabs || [];
    const index = component.state.activeTabIndex;
    if (!Array.isArray(tabs) || !Number.isInteger(index)) return false;
    const currentTab = tabs[index] || {};
    const fields = currentTab.fields || [];

    for (let i = 0; i < fields.length; i += 1) {
      const fieldPath = fields[i];
      if (isFieldRequired(fieldPath) && isEmptyValue(_.get(component.state.formData || {}, fieldPath))) {
        const id = `root_${fieldPath.replace(/\./g, '_')}`;
        component.changeFirstError(id);
        return true;
      }
      if (isCheckBoxWithDynamicInputField(fieldPath) && isCheckBoxWithDynamicInputFieldRequired(fieldPath)) {
        const segments = (fieldPath || '').split('.');
        const parentPath = segments.join('.');
        const requiredFields = component.state.formData?.[parentPath]?.selected?.filter(
          // eslint-disable-next-line no-unsafe-optional-chaining
          value => !(`${value}_input` in component?.state?.formData?.[parentPath])
        );
        if (requiredFields.length > 0) {
          const id = `root_${fieldPath.replace(/\./g, '_')}_${requiredFields[0]}_input`;
          component.changeFirstError(id);
          return true;
        }

        return true;
      }
    }
    return false;
  };

  const handleTabSelect = nextIndex => {
    const currentIndex = component.state.activeTabIndex;
    if (!Number.isInteger(currentIndex)) return;
    if (nextIndex === currentIndex) return;
    if (nextIndex < currentIndex) {
      component.setState({ activeTabIndex: nextIndex, showError: false, firstError: null });
      return;
    }
    if (tabHasMissingRequired()) {
      component.setState({ showError: true }, () => component.focusInputError());
      return;
    }
    component.setState({ activeTabIndex: nextIndex, showError: false, firstError: null });
  };

  const handleNextTab = () => {
    if (!Number.isInteger(component.state.activeTabIndex)) return;
    if (isLastTab()) return;
    if (tabHasMissingRequired()) {
      component.setState({ showError: true }, () => component.focusInputError());
      return;
    }
    component.setState(
      prev => ({ activeTabIndex: prev.activeTabIndex + 1, showError: false, firstError: null }),
      () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    );
  };

  return {
    isLastTab,
    handleTabSelect,
    handleNextTab,
  };
};
